import React from 'react';
import { observer } from 'mobx-react';

import { ROUTES } from 'shared/constants';
import { toDate } from 'shared/utilities';
import { UiLoadingSpinner, UiNavLink } from 'shared/uikit-new';
import { useAsyncEffect, useObservable } from 'shared/hooks';
import { tasksGetQuery, tasksSaveQuery } from 'shared/queries/TaskTracker';
import { TaskModel } from 'shared/models/TaskTracker';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationTaskTrackerTaskExpiredAtProposeOwner = observer(function VmNotificationTaskTrackerTaskExpiredAtProposeOwner(
    {
        notification,
        onClose = () => undefined,
        onDelete = () => undefined,
    }: PropsType,
) {
    const store = useObservable({
        isLoading: true,
        taskTrackerTask: new TaskModel(),
    });

    useAsyncEffect(async () => {
        const response = await tasksGetQuery({ id: notification.data.task.id });
        if (response.isSuccess && response.data) {
            store.set('taskTrackerTask', new TaskModel(response.data.item));

            if (
                !store.taskTrackerTask.expiredAtPropose ||
                store.taskTrackerTask.expiredAtPropose !== notification.data.task.expiredAtPropose ||
                store.taskTrackerTask.expiredAtProposeUserId !== notification.data.task.expiredAtProposeUserId ||
                store.taskTrackerTask.expiredAtProposeComment !== notification.data.task.expiredAtProposeComment
            ) {
                onDelete(notification);
            } else {
                store.set('isLoading', false);
            }
        } else {
            onDelete(notification);
        }

    }, []);

    const handleConfirm = async () => {
        tasksSaveQuery({
            id: notification.data.task.id,
            expiredAt: store.taskTrackerTask.expiredAtPropose || store.taskTrackerTask.expiredAt,
            expiredAtPropose: null,
            expiredAtProposeUserId: null,
            expiredAtProposeComment: null,
            expiredAtProposeIsAccepted: true,
            expiredAtProposeIsAcceptedComment: null,
        });
        onDelete(notification);
    };

    const handleDeny = async () => {
        tasksSaveQuery({
            id: notification.data.task.id,
            expiredAtPropose: null,
            expiredAtProposeUserId: null,
            expiredAtProposeComment: null,
            expiredAtProposeIsAccepted: false,
            expiredAtProposeIsAcceptedComment: null,
        });
        onDelete(notification);
    };

    return (
        <div className={'vm-notification__content'}>
            <UiLoadingSpinner isLoading={store.isLoading} size={36}>
                <div className={'vm-notification__name'}>Запрос на изменение сроков задачи</div>
                <div className="vm-notification__description">
                    <span>{notification.data.task.expiredAtProposeUser.previewName} хочет изменить сроки задачи </span>
                    <UiNavLink to={ROUTES.TASK_TRACKER_TASK(notification.data.task.id)} onClick={onClose}>[№{notification.data.task.id}] {notification.data.task.name}</UiNavLink>
                </div>
                <div className="vm-notification__additional">
                    <div>
                        <label style={{ width: 95 }}>Текущий срок:</label>
                        <span>{toDate(notification.data.task.expiredAt).format('DD.MM.YYYY')}</span>
                        <svg className="vm-notification__pointer" width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.646447 17.6464C0.451184 17.8417 0.451184 18.1583 0.646447 18.3536L3.82843 21.5355C4.02369 21.7308 4.34027 21.7308 4.53553 21.5355C4.7308 21.3403 4.7308 21.0237 4.53553 20.8284L1.70711 18L4.53553 15.1716C4.7308 14.9763 4.7308 14.6597 4.53553 14.4645C4.34027 14.2692 4.02369 14.2692 3.82843 14.4645L0.646447 17.6464ZM1 18.5H13.5V17.5H1V18.5ZM13 0H1V1H13V0ZM22.5 9.5C22.5 4.2533 18.2467 0 13 0V1C17.6944 1 21.5 4.80558 21.5 9.5H22.5ZM13.5 18.5C18.4706 18.5 22.5 14.4706 22.5 9.5H21.5C21.5 13.9183 17.9183 17.5 13.5 17.5V18.5Z"
                                fill="#5F6269"
                            />
                        </svg>
                    </div>
                    <div>
                        <label style={{ width: 95 }}>Новый срок:</label>
                        <span>{toDate(notification.data.task.expiredAtPropose).format('DD.MM.YYYY')}</span>
                    </div>
                    {!!notification.data.task.expiredAtProposeComment && (
                        <div>
                            <label style={{ width: 95 }}>Комментарий:</label>
                            <span>{notification.data.task.expiredAtProposeComment}</span>
                        </div>
                    )}
                </div>
                <div className="vm-notification__actions">
                    <div onClick={handleConfirm}>Подтвердить</div>
                    <div onClick={handleDeny}>Отказать</div>
                </div>
            </UiLoadingSpinner>
        </div>
    );
});
